(function () {
  angular
    .module("akitabox.ui.components.buildingInfo")
    .factory("EditBuildingDialog", EditBuildingDialog);

  /** @ngInject */
  function EditBuildingDialog($log, $q, $mdDialog) {
    var config = {
      templateUrl:
        "app/core/ui/components/building-info/edit-building.dialog.html",
      controller: "EditBuildingDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
      focusOnOpen: false,
    };

    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog, required options:
     *     `options.locals.buildingId`
     *
     * @param  {Object}                 options     Dialog options
     *
     * @return {Promise<Object|Error}               Promise that resolves with
     *                                              the updated building
     */
    function show(options) {
      if (!options || !options.locals || !options.locals.building) {
        $log.error(
          "EditBuildingDialog: you must pass in a building via locals"
        );
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      angular.extend(config, options);
      return $mdDialog.show(config);
    }
  }
})();
